import { useState } from "react";

const FALLBACK =
  "data:image/svg+xml," +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="800" height="600"><rect width="800" height="600" fill="#202124"/><path d="M400 210l-60 120h50l-30 90 90-130h-55l35-80z" fill="#F5B700" opacity="0.9"/><text x="400" y="500" font-family="monospace" font-size="22" fill="#667085" text-anchor="middle">[ADD BUSINESS PHOTO]</text></svg>`
  );

export default function SafeImage({ src, alt = "", className = "", ...rest }) {
  const [err, setErr] = useState(false);
  const [small, setSmall] = useState(false);
  const base = (typeof window !== "undefined" && window.BACKEND_URL) || process.env.REACT_APP_BACKEND_URL || "";
  const resolved = src && src.startsWith("/api/") ? `${base}${src}` : src;
  const finalSrc = !resolved || err ? FALLBACK : resolved;

  const onLoad = (e) => {
    // Small source images look sharper contained at natural size than stretched
    if (e.target.naturalWidth && e.target.naturalWidth < 460) setSmall(true);
  };

  const fit = small ? "object-contain p-6 bg-white" : "object-cover";
  const cleaned = small ? className.replace(/object-cover/g, "") : className;

  return (
    <img
      src={finalSrc}
      alt={alt}
      loading="lazy"
      decoding="async"
      onError={() => setErr(true)}
      onLoad={onLoad}
      className={`${fit} ${cleaned}`}
      {...rest}
    />
  );
}
